import './Splash.less';

export const prefix = 'bm-c-splash';

export { default } from './Splash';
